import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Toaster } from "react-hot-toast";
import ScrollToTop from "./ScrollToTop";

const Layout = ({ 
  children, 
  scrollToSection, 
  inicioRef, 
  serviciosRef, 
  equipoRef, 
  preguntasRef, 
  infoRef 
}) => {
  return (
    <div className="app-container">
      <Header 
        scrollToSection={scrollToSection}
        inicioRef={inicioRef}
        serviciosRef={serviciosRef}
        equipoRef={equipoRef}
        preguntasRef={preguntasRef}
        infoRef={infoRef}
      />
      <main className="main-content">
        {children}
        <ScrollToTop />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
};

export default Layout;
